'use client';

import { useEffect, useState } from 'react';

import { CountryCode } from '@cineamo/api/types/CountryCode';

import { Locale } from '../constants/locale-constants';
import { getLocaleFromLanguage } from '../helpers/locale-helper';
import { toApiCountryCode, toISO_3166_1 } from '../helpers/type-guards';

type UseBrowserLocaleReturn = {
    locale: Locale | undefined;
    countryCode: CountryCode | undefined;
    localeAlt: string | undefined;
};

export default function useLocale(): UseBrowserLocaleReturn {
    // const router = useRouter();
    const [browserLocale, setBrowserLocale] = useState<string>();
    const [countryCode, setCountryCode] = useState<CountryCode>();
    const locale =
        // browserLocale?.startsWith(router.locale?.substring(0, 2) || '')
        // ? getLocaleFromLanguage(router.locale)
        // :
        getLocaleFromLanguage(browserLocale);

    useEffect(() => {
        const localeToUse = getLocaleFromLanguage(typeof navigator !== 'undefined' ? navigator.language : undefined);
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional: reading navigator.language must happen on the client after mount
        setBrowserLocale(localeToUse);

        if (localeToUse?.length > 2) {
            setCountryCode(toApiCountryCode(toISO_3166_1(localeToUse.substring(3, 5))));
        }

        // Only do a router.replace if the localeToUse != the router.locale
        // if (router.locale === getLanguageCodeFromLocale(localeToUse)) {
        //     return;
        // }
        //
        // router
        //     .replace(
        //         {
        //             pathname: router.pathname,
        //             query: router.query
        //         },
        //         undefined,
        //         { locale: getLanguageCodeFromLocale(localeToUse) }
        //     )
        //     .then();
    }, []);

    return {
        locale: browserLocale ? locale : undefined,
        countryCode: countryCode,
        localeAlt: browserLocale
    };
}
